module.exports = __webpack_public_path__ + "media/images/animations/number_of_tires/1-368772afb8555eb04c2d85d7b411d0a1.png";